import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { usePostComment } from 'actions/comments';
import CommentForm from '../CommentForm';
import CommentFormTitleBar from '../CommentForm/CommentFormTitleBar';
import Comment from './Comment';
import Replies from './Replies';
import CommentWrapper from './CommentWrapper';
import { useCommentsContext } from '../Context';
import { CommentAvatarWrapper } from '../Shared';
function CommentController(_ref) {
  var comment = _ref.comment,
    user = _ref.user,
    size = _ref.size;
  var id = comment.id,
    author = comment.author;
  var _useTranslation = useTranslation(),
    _useTranslation2 = _slicedToArray(_useTranslation, 1),
    t = _useTranslation2[0];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isReplying = _useState2[0],
    setIsReplying = _useState2[1];
  var _useState3 = useState('idle'),
    _useState4 = _slicedToArray(_useState3, 2),
    submissionStatus = _useState4[0],
    setSubmissionStatus = _useState4[1];
  var _useCommentsContext = useCommentsContext(),
    contentId = _useCommentsContext.contentId,
    contentType = _useCommentsContext.contentType;
  function onSuccess() {
    setSubmissionStatus('success');
    setIsReplying(false);
  }
  function onError() {
    setSubmissionStatus('error');
    setIsReplying(false);
  }
  var _usePostComment = usePostComment({
      contentId: contentId,
      contentType: contentType,
      parentId: id,
      onSuccess: onSuccess,
      onError: onError
    }),
    postReply = _usePostComment.postComment;
  function submitReply(_x) {
    return _submitReply.apply(this, arguments);
  }
  function _submitReply() {
    _submitReply = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(message) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return postReply(message);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _submitReply.apply(this, arguments);
  }
  var wrapperRef = useRef(null);
  var isUserComment = author.id === user.id;
  return /*#__PURE__*/React.createElement(CommentWrapper, {
    ref: wrapperRef,
    comment: comment,
    isUserComment: isUserComment
  }, /*#__PURE__*/React.createElement(Comment, {
    comment: comment,
    onReply: function onReply() {
      return setIsReplying(true);
    },
    isUserComment: isUserComment,
    size: size
  }), isReplying && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CommentFormTitleBar, {
    isNested: true,
    title: t('reply_to_comment', {
      name: author.displayName
    }),
    onClose: function onClose() {
      return setIsReplying(false);
    }
  }), /*#__PURE__*/React.createElement(CommentAvatarWrapper, {
    isNested: true,
    pictureUrl: user.pictureUrl
  }, /*#__PURE__*/React.createElement(CommentForm, {
    focusOnMount: true,
    inputLabel: t('actions_reply'),
    submitButtonLabel: t('actions_reply'),
    size: size,
    submissionStatus: submissionStatus,
    onSubmit: submitReply,
    onResetSubmitStatus: function onResetSubmitStatus() {
      return setSubmissionStatus('idle');
    },
    submitSuccessMessage: t('comment_submit_success')
  }))), contentId && /*#__PURE__*/React.createElement(Replies, {
    contentId: contentId,
    comment: comment,
    user: user,
    size: size
  }));
}
export default CommentController;